import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { GameModeService } from '../../_services/game-mode.service';
import { ClassStudentsService } from '../../_services/class-students.service';
import { CallingScreenService } from '../../../_services/calling-screen.service';
import { GlobalService } from 'src/app/_services/global.service';
import { environment } from 'src/environments/environment';

interface StudentCheckItem {
  id: number;
  name: string;
  gender: string;
  image_path: string | null;
  audio_file_path: string | null;
  attendance: any[] | null;
  class_id: number;
  grade_id: number;
  selected: boolean;
}

@Component({
  selector: 'app-student-loading',
  templateUrl: './student-loading.component.html',
  styleUrls: ['./student-loading.component.scss']
})
export class StudentLoadingComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();
  currLang: any = 'en';
  loading = true;
  students: StudentCheckItem[] = [];

  constructor(
    private gameModeService: GameModeService,
    private classStudentsService: ClassStudentsService,
    private callingScreenService: CallingScreenService,
    private globalService: GlobalService
  ) {}

  ngOnInit(): void {
    this.globalService.getLang()
      .pipe(takeUntil(this.destroy$))
      .subscribe(lang => this.currLang = lang);

    const classId = this.gameModeService.getCurrentClassId();
    if (classId) {
      this.callingScreenService.getClassAttendance(classId)
        .pipe(takeUntil(this.destroy$))
        .subscribe({
          next: (response: any) => {
            this.students = (response || []).map((s: any) => ({
              id: s.id,
              name: s.name,
              gender: s.gender,
              image_path: s.image_path,
              audio_file_path: s.audio_file_path,
              attendance: s.attendance,
              class_id: s.class_id,
              grade_id: s.class?.grade_id || 0,
              selected: true
            }));
            this.loading = false;
            // Phase 1: auto-confirm all students and proceed to hub
            this.confirm();
          },
          error: (err) => {
            console.error('Error fetching class attendance:', err);
            this.loading = false;
          }
        });
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  toggleStudent(student: StudentCheckItem): void {
    student.selected = !student.selected;
  }

  get selectedCount(): number {
    return this.students.filter(s => s.selected).length;
  }

  confirm(): void {
    const classId = this.gameModeService.getCurrentClassId();
    const selected = this.students.filter(s => s.selected).map(s => ({
      id: s.id,
      name: { en: s.name, ar: s.name },
      gender: s.gender as 'male' | 'female',
      class_id: s.class_id,
      grade_id: s.grade_id,
      image_path: s.image_path,
      audio_file_path: s.audio_file_path,
      attendance: s.attendance
    }));
    this.classStudentsService.setRealStudents(selected);
    if (classId) {
      this.gameModeService.proceedToHub(classId);
    }
  }

  goBack(): void {
    this.gameModeService.setAvailableClasses(this.gameModeService.getAvailableClasses());
    this.gameModeService.openClassSelect();
  }

  getImageUrl(imagePath: string | null): string {
    return imagePath ? environment.img_url + imagePath : '';
  }

  hasCustomImage(imagePath: string | null): boolean {
    if (!imagePath) return false;
    const filename = imagePath.split('/').pop() || '';
    return filename !== 'avatar.png';
  }
}
